
import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { shortDate } from '../lib/timeFormat';
import { Link } from 'react-router-dom';
import Header from '../common/Header';
import SearchBar from '../Search';
import Modal from './Modal';
import Footer from '../common/Footer';

// import { formatDuration } from '../lib/timeFormat';
import usePageTracking from '../lib/usePageTracking';

// import Filters from './Filters';
import OfferCard from './OfferCard';
import LoadingIndicator from '../common/LoadingIndicator';
import useApi from './useApi';
import { useAuthContext } from '../Auth/context';

import styles from '../assets/css/offers.module.css';
import Loader from '../assets/img/loader.svg';
// import { DUMMY_OFFER_REQUEST } from '../constants';

const OffersList = () => {
  const navigate = useNavigate();
  const { state: { jwt, loggedIn, logged } } = useAuthContext();
  const [guestUser, setGuestUser] = useState(false);
  const [pendingBooking, setPendingBooking] = useState(null);

  const redirectToBooking = useCallback(
    (bookingId, source, params, guestUser) => {
      const bookingURL = `../booking/${bookingId}`;
      const bookingState = { source, params, guestUser };
      if (guestUser || loggedIn || logged) {
        navigate(bookingURL, { state: bookingState });
      } else {
        localStorage.setItem('pendingBookingURL', bookingURL);
        localStorage.setItem('pendingBookingState', JSON.stringify(bookingState));
        navigate('../login');
      }
    },
    [navigate]
  );

  useEffect(() => {
    if (pendingBooking) {
      redirectToBooking(pendingBooking.bookingId, pendingBooking.source, pendingBooking.params, guestUser);
      setPendingBooking(null);
    }
  }, [guestUser, pendingBooking]);

  const { referral_code: referralCode } = useParams();
  const { state: params } = useLocation();
  const [currency, setCurrency] = useState();
  const [sortBy, setSortBy] = useState();
  const [filters, setSearchFilters] = useState({
    passengers: { adults: 1, children: 0, infants: 0 },
    baggage: { hold: 1, carryOn: 0 }
  });
  const [showModal, setShowModal] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const [searchParams, setSearchParams] = useState(params);
  const {
    actions: { searchOffers, createBooking },
    data: { offers = [], bestOffers = {}, suggestions },
    status,
    errorMessage
  } = useApi({ redirectToBooking, setPendingBooking });

  // const [showFiltersModal, setShowFiltersModal] = useState(false); // Uncomment with side filters
  useEffect(() => {
    setSearchParams((params)=>({...params,...filters}));
  }, [filters]);

  useEffect(() => {
    if (suggestions.length === 1 && status !== 'loading') {
      createBooking({ ...suggestions[0], referralCode }, filters, 'suggestions', params);
    }
  }, [suggestions, referralCode, filters]);
  const handleSearchChange = (key, update) => {

    if (typeof update === 'string' || typeof update === 'object') setSearchFilters({ ...filters, [key]: update });
    else setSearchFilters({ ...filters, [key]: { ...filters[key], ...update } });
  };

  const sendMessage = () => {
    const phoneNumber = '249999990558';
    let message;
    if (searchParams) {
      message =
        `${searchParams.departureStation.iataCode} → ${searchParams.destinationStation.iataCode}
${searchParams.departureDate ? shortDate(searchParams.departureDate) : ''}${searchParams.returnDate ? ' → ' + shortDate(filters.returnDate) : ''}
Class: ${searchParams.cabinClass ? searchParams.cabinClass : 'any'} | Adults: ${searchParams.adults} | Children: ${searchParams.children} | Infants: ${searchParams.infants}`;
    }

    const encodedMessage = encodeURIComponent(message);

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, '_blank');
  };

  const handleGuest = (value) => {
    setGuestUser(value);
  };

  usePageTracking();
  return (
    <>
      <header className={styles.offers_header}>
        <Header selectCurrency={setCurrency} />

        <SearchBar
          className="splash-form-offers"
          handleSearch={searchOffers}
          params={searchParams}
          currency={currency}
          status={status}
          sortBy={sortBy}
          onSearchChange={handleSearchChange}
        />

        <LoadingIndicator loading={status === 'loading'} />
      </header>

      <main className={styles.offers_wrapper}>
        {/* <section>
          <Filters hide={styles.mobile_hidden} />
        </section> */}
        <section className={styles.offers_container}>

          {
            offers && offers.length > 0 ?
              <div className={styles.best_offers}>
                <div className={sortBy === 'price' ? styles.active_offer_sort : styles.offer_sort} onClick={() => setSortBy('price')}>
                  <p className={styles.best_offers_title}>الأقل سعرا</p>
                </div>
                <div className={sortBy === 'duration' ? styles.active_offer_sort : styles.offer_sort} onClick={() => setSortBy('duration')}>
                  <p className={styles.best_offers_title}>الأسرع</p>
                </div>
              </div>
              :
              <div>
                {
                  status === 'request-complete' && offers.length === 0 && suggestions && suggestions.length === 0 &&
                  <>
                    <div className='no-results'>
                      <p style={{ marginBottom: 0 }}>نعتذر، هذه الرحلة غير متاحة حالياً عبر المنصة.</p>
                      <p style={{ fontSize: '0.85em', marginTop: 8 }}>يسعدنا مساعدتك عبر خدمة العملاء لإكمال حجزك.</p>
                      <div onClick={sendMessage} className='button' style={{ fontSize: '0.9em', display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                        <i style={{ color: '#25d366', marginLeft: 12 }} className="fab fa-whatsapp"></i>
                        خدمة العملاء
                      </div>
                    </div>
                  </>
                }
                {
                  status === 'loading' &&
                  <div className='no-results loading'>
                    <img alt="جاري البحث ..." src={Loader} />
                  </div>
                }
                {
                  status === 'initial' &&
                  <div className='no-results'>
                    <p>ابدأ بحثك للعثور على آخر عروض الرحلات</p>
                  </div>
                }
                {
                  status === 'request-failed' &&
                  <div className='no-results'>
                    <p>{errorMessage}</p>
                    <span className="iconify" data-icon="zondicons:exclamation-solid"></span>
                  </div>
                }
              </div>
          }
          {suggestions && suggestions.length > 1 && status !== 'loading' && <div className='suggestions-container'>
            <h4 className='suggested-flights-title'>
              <span className="iconify" data-icon="zondicons:exclamation-solid"></span>
              رحلات في تواريخ بديلة</h4>
            <div>
              {
                suggestions.map((flight, index) => {

                  if (suggestions.length > 1)
                    return (
                      <OfferCard
                        offer={flight}
                        key={flight.reference}
                        createBooking={() => createBooking({ ...flight, referralCode }, filters, guestUser)}
                        submitting={status === 'submitting'}
                        error={errorMessage}
                        handleGuest={handleGuest}
                        suggested
                      />
                    );
                  else if (showSuggestions && index > 2) {
                    return (
                      <div
                        key={flight.reference}
                        style={{ display: showSuggestions ? 'block' : 'none' }}
                      >
                        <OfferCard
                          offer={flight}
                          createBooking={() => createBooking({ ...flight, referralCode }, filters, guestUser)}
                          submitting={status === 'submitting'}
                          error={errorMessage}
                          handleGuest={handleGuest}
                          suggested
                        />
                      </div>
                    );
                  }
                  return null;
                })
              }
              {suggestions.length > 3 && <button className="button show-more" onClick={() => { setShowSuggestions(!showSuggestions); }}
              >
                {showSuggestions ? 'عرض اقتراحات اقل' : 'عر ض المزيد من الإقتراحات'}
                <i className={showSuggestions ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
              </button>
              }
            </div>
          </div>
          }
          {
            offers.map((offer) => (
              <OfferCard
                offer={offer}
                key={offer.reference}
                createBooking={() => createBooking({ ...offer, referralCode }, filters, guestUser)}
                submitting={status === 'submitting'}
                handleGuest={handleGuest}
                error={errorMessage}
              />
            ))
          }

          {status === 'fetching-more' && <div className='no-results'>
            <img alt="جاري التحميل ..." src={Loader} />
          </div>}
        </section>

        {
          showModal && <Modal content={
            <div>
              <div className='pop-up'>
                <div>
                  <p className='pop-up-title'>لقد انتهى الزمن المحدد</p>
                  <p>يرجى تحديث الصفحة لرؤية آخر العروض</p>
                </div>
              </div>
            </div>
          } background={true} mode="tiny" onClose={() => setShowModal(false)} />
        }
      </main >
      <Footer />
    </>
  );
};

export default OffersList;
